import PropTypes from 'prop-types';
import React from 'react';

import { useObserver } from '../../tools/useObserver';
import ContentfulImage from '../Common/ContentfulImage';
import { ArrowLink } from '../Common/Links';
import PageSection from '../Common/PageSection';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import SmartLink from '../Common/SmartLink';
import { AutoPauseVideo } from './AutoPauseVideo';
import * as styles from './HalfBGContentCard.module.css';

const CenteredImageContainer = ({ section, imageSide, bgStyles }) => {
  return (
    <div style={bgStyles} className={styles['image' + imageSide]}>
      {/*<div className={[styles.background].join(' ')} style={bgStyles} />*/}
      {/*<div className={styles.mainImageContainer}>*/}
      <ContentfulImage
        objectFit={'contain'}
        className={[styles['image' + imageSide], styles.mainImage].join(' ')}
        imageFragment={section.mainImage}
      />
      {/*</div>*/}
    </div>
  );
};

const SimpleTestimonial = ({ testimonial }) => {
  let attribution = (
    <>
      <span className={testimonial.company ? styles.lighten : ''}>{testimonial.attribution}</span>
      {testimonial.company && <span>{testimonial.company}</span>}
    </>
  );
  if (!!testimonial.attributionUrl) {
    attribution = (
      <SmartLink to={testimonial.attributionUrl}>
        <span className={testimonial.company ? styles.lighten : ''}>{testimonial.attribution}</span>
        {testimonial.company && <span>{testimonial.company}</span>}
      </SmartLink>
    );
  }

  return (
    <div className={testimonial.logo && styles.testimonial}>
      {testimonial.logo && <ContentfulImage imageFragment={testimonial.logo} />}
      <div>
        <p>{testimonial.quote.quote}</p>
        {attribution}
      </div>
    </div>
  );
};

const gradients = {
  Pink: 'linear-gradient(180deg, rgba(248,89,139, 0.9) 0%, rgba(155,21,63, 0.9) 100%)',
  Blue: 'linear-gradient(180deg, rgba(0,156,226, 0.9) 0%, rgba(3,51,103, 0.9) 100%)',
  Purple: 'linear-gradient(180deg, rgba(128,83,255, 0.9) 0%, rgba(43,24,97, 0.9) 100%)',
  Green: 'linear-gradient(180deg, rgba(15,166,157, 0.9) 0%, rgba(3,69,73, 0.9) 100%)',
};

const HalfBGContentCard = ({ section, imageSide = 'Left', slideIn = false }) => {
  const [containerRef, containerVisible] = useObserver();

  const bgStyles = {
    '--bg-image': `url('${section.mainImage?.background?.src}')`,
    '--bg-overlay': gradients[section.imageBackgroundGradient],
  };
  const hasTestimonial = section?.contentSection?.__typename === 'ContentfulTestimonial';
  const bgColor = section.backgroundColor === 'Grey' ? styles.grey : styles.white;
  return (
    <PageSection fullBleed noPad className={[bgColor, styles.padTop].join(' ')} style={bgStyles}>
      <div className={styles.maxWidth}>
        {/*<div className={[styles.halfBackground].join(' ')} style={bgStyles} />*/}
        <div className={styles.copyGrid} ref={containerRef}>
          <div className={[styles['copy' + imageSide]].join(' ')}>
            {section.title && <h3>{section.title}</h3>}
            <RichTextConverter copy={section.copy} />
            {section.ctaLabel && (
              <ArrowLink
                label={section.ctaLabel}
                url={section.ctaUrl}
                isExternal={section.newWindow}
                isDownload={section.ctaIsDownload}
              />
            )}
            {hasTestimonial && <SimpleTestimonial testimonial={section.contentSection} />}
          </div>
        </div>
        <div
          className={[
            styles.imageBackgroundGrid,
            slideIn && styles.animate,
            containerVisible && slideIn && styles.visible,
          ].join(' ')}
        >
          <div className={styles.sepGrid}>
            <div className={styles.imageBackground} />
            <div className={styles.imageWrap}>
              {section.wistiaUrl ? (
                <AutoPauseVideo src={section.wistiaUrl} classes={[styles.videoPlayer]} />
              ) : (
                <CenteredImageContainer section={section} imageSide={imageSide} bgStyles={bgStyles} />
              )}
            </div>
          </div>
        </div>
      </div>
    </PageSection>
  );
};

HalfBGContentCard.propTypes = {
  section: PropTypes.object,
};

export default HalfBGContentCard;
